import Toast from 'light-toast';
export const Functions = {
    logout: () => {
        localStorage.removeItem('provider_token');
        localStorage.removeItem('provider_data');
        localStorage.removeItem('location_data');
        window.location.replace('');
    },
    error: (status) => {
        console.log(status)
        if(status === 401) {
            Toast.fail('Utilizador não encontrado.');
            Functions.logout();
        } else if(status === 403) {
            Toast.fail('Sem permissões para aceder a este recurso.');
        } else if(status === 404) {
            Toast.fail('Recurso não existente.');
        } else if(status === 409) {
            Toast.fail('Informação já existente na base de dados.');
        } else {
            Toast.fail('Ocorreu um erro.', 3000);
        }
    },
};